import { BllSiparisDetay } from './../../../providers/bll/bll-siparis-detay';
import { BarcodeScannerProvider } from './../../../providers/barcode-scanner-provider';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { CarisecPage } from './../../faturaislemleri/carisec/carisec';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController, Searchbar } from 'ionic-angular';
import { OzetPage } from '../../faturaislemleri/ozet/ozet';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-alis-faturalari',
  templateUrl: 'alis-faturalari.html',
})
export class AlisFaturalariPage {
  aranan = "";
  skip: number = 0;
  take: number = 100;
  stokListesi = [];
  aktifkullaniciadi="";
  Cari: any = { ID: 1, Definition_: "" };
  Siparis: any = {
    ID: "", StokKartID: "", IslemTuru: "", FaturaID: "", CariKartID: "", Miktar: "",
    BirimFiyat: "", Tutar: "", NetFiyat: "", Kdv: "", KdvOran: "", UrunAdi: "", IskontoOran1: "", IskontoOran2: "", IskontoOran3: ""
    , IskontoTutar: "", IskontoluBirimFiyat: "", SatirNo: ""
  };
  @ViewChild('searchbar') searchbar: Searchbar;
  constructor(public navCtrl: NavController,
    public modalCtrl: ModalController,
    public view: ViewController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    private barcodeScanner:BarcodeScannerProvider,
    public toast: ToastController,
    public navParams: NavParams) {
      this.aktifkullaniciadi=this.ortak.storagePersonelGetir.Name;
  }

  ionViewDidLoad() {
    this.carisec();
    this.urunAra();
    this.cacheTemizle();
    }
    ionViewDidEnter() {
      setTimeout(() => {
        this.searchbar.setFocus();
      });
    }

  carisec() {
    var modal = this.modalCtrl.create(CarisecPage);
    modal.onDidDismiss(a => {
      if (a != null) {
        this.Cari = a;
        if (this.Cari.ID > 1) {
        }
        else {
        }
      }
    });
    modal.present();
  }
  urunler(e) {
    if (e.keyCode == 13) {
      this.urunAra();
    }
  }
  urunAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take",  this.ortak.StAyarGetir.MalzemeListeSayisi.toString());
    formData.append("katid","-1");
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.stokListesi = sonuc.SonucObject;
    })
  }
  urunItemClick(Urun) {
    this.ortak.alertAktarimPenceresi(Urun).then(a => {
      var sonuc = <any>a;
      var values = sonuc.values;
      var Miktar = values.Miktar;
      var Fiyat = values.Fiyat;
      if(Miktar==""||Miktar==null)
      {
        Miktar=1;
      }
      this.Siparis.Miktar = Miktar;
      this.Siparis.BirimFiyat = Fiyat;
      this.Siparis.StokKartID = Urun.ID;
      this.Siparis.CariKartID = this.Cari.ID;
      this.Siparis.IslemTuru = 2;
      this.Siparis.Tutar = Fiyat * Miktar;
      this.Siparis.NetFiyat = Fiyat * Miktar;
      this.Siparis.KdvOran = Urun.Vat;
      this.Siparis.UrunAdi = Urun.StokAdi;
      this.Siparis.IskontoOran1 = 0;
      this.Siparis.IskontoOran2 = 0;
      this.Siparis.IskontoOran3 = 0;
      this.Siparis.IskontoTutar = 0;
      this.Siparis.IskontoluBirimFiyat = 0;
      var bllSiparisDetay = new BllSiparisDetay();
      bllSiparisDetay.alisfaturasiDetayEkle_Temp(this.Siparis.StokKartID, this.Siparis.CariKartID, this.Siparis.Miktar, this.Siparis.BirimFiyat, this.Siparis.Tutar,
       this.Siparis.KdvOran, this.Siparis.NetFiyat, -994, this.Siparis.UrunAdi, 255,this.aktifkullaniciadi).then(a => {
          this.presentToast(Urun.StokAdi + " " + "Eklendi");
          this.aranan="";
          this.ionViewDidEnter();

        })

    });

  }
  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
      position: 'top'
    });
    toast.present();
  }
  ozet() {
    let modal = this.modalCtrl.create(OzetPage,{faturatip:2});
    modal.onDidDismiss(data => {
  
    });
    modal.present();
  }
  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
          this.aranan = sonuc.text;
     this.urunAra();
     
    })
  }
  cacheTemizle() {
      var bllSiparisDetay = new BllSiparisDetay();
      bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + -994).then(b => {
          }).catch(x => {
        console.log(x);
      })
    }
 kapat()
 {
   this.view.dismiss();
 }
}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/alis-faturalari/alis-faturalari.ts